import { useEffect, useRef } from 'react';

import './styles/InputCode.css';

export default function InputCode({ children, className, codeType="alphanumeric", value, onChange, readOnly, onComplete, elementName }) {
  const inputFieldsRef = useRef([]);
    
  function validateInputFieldValue(inputFieldValue) {
    if(codeType === "numeric") {
      return /^[0-9]*$/.test(inputFieldValue);
    } else if(codeType === "alphanumeric") {
      return /^[a-z0-9]*$/i.test(inputFieldValue);
    } else {
      return false;
    }
  }

  function handleCodeInput(inputFieldValue, inputFieldIndex) {
    if(validateInputFieldValue(inputFieldValue)) {
      const newCode = [...value];
      newCode[inputFieldIndex] = inputFieldValue;
      onChange(newCode);

      if(!newCode.includes("") && onComplete) {
        onComplete(newCode);
      } else if(inputFieldValue !== "") {
        inputFieldsRef.current[inputFieldIndex+1]?.focus();
      }
    }  
  }

  const onKeyDown = (event, index) => {
    if(event.code === "Backspace") {
      if(index > 0 && !value[index]) {
        inputFieldsRef.current[index-1]?.focus();
      }
    }
  };

  // we set the focus to the first element
  useEffect(() => {
    inputFieldsRef.current[0]?.focus();
  }, []);

  return (
    <>
      <div className={className}>
        <div className="input-code">
          {value.map((inputFieldValue, inputFieldIndex)=>(
            <input 
              type="text"
              key={inputFieldIndex}
              readOnly={readOnly}
              spellCheck={false}
              autoComplete="one-time-code"
              autoCorrect="off"
              autoCapitalize="none"
              maxLength={1}
              id={`${elementName}-${inputFieldIndex}`}
              tabIndex={inputFieldIndex}
              className="input-code__input"
              value={inputFieldValue}
              onChange={e=>handleCodeInput(e.target.value, inputFieldIndex)}
              onKeyDown={event => onKeyDown(event,inputFieldIndex)}
              ref={ref=>inputFieldsRef.current.push(ref)}
            />
          ))}
        </div>
        <div className="children">
          {children}
        </div>
      </div>

    </>
  );
}
